<template>
    <div
        class="flex p-4 bg-gray-50"
    >
        <div class="sl-card">
            <div class="sl-card__title">
                {{ t('card.pack_order_contents.title') }}
            </div>

            <table>
                <tbody>
                    <tr
                        v-for="(order, i) in row.child_orders"
                        :key="order.id"
                        :class="{ 'bg-gray-50': i % 2 }"
                    >
                        <td class="sl-card-table-cell sl-card-table-cell__label">
                            {{ getArticleLabel(order.article) }}
                        </td>

                        <td class="sl-card-table-cell sl-card-table-cell__value pl-8">
                            <div class="flex justify-between items-start gap-2">
                                <div class="text-left">
                                    {{ order.currency_code }}
                                </div>

                                <div class="text-right">
                                    {{ order.total.toFixed(2) }}
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

const props = defineProps({
    /** The pack order. */
    row:
    {
        type:     Object,
        required: true,
    },

    updating:
    {
        type:    Boolean,
        default: false,
    },
});

const { t } = useI18n();
const store = useStore();

function getArticleLabel(article)
{
    return store.getters['catalog/getLabelByCode'](article.code)
        ?? article.label;
}
</script>
